import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Duolingo-style character avatar + speech bubble. Keyword inside the bubble
 * gets a dotted underline drawn with repeated background gradient (matches the
 * production pattern where they use an SVG background-image).
 */
export function CharacterBubble({ name, color, initials, children, keyword }) {
    const text = typeof children === 'string' && keyword
        ? splitKeyword(children, keyword)
        : null;
    return (_jsxs("div", { className: "sl-char-row", children: [_jsx("div", { className: "sl-char-avatar", style: { background: color }, "aria-label": name, children: initials }), _jsx("div", { className: "sl-bubble", role: "note", children: text ? (_jsxs(_Fragment, { children: [text.before, _jsx("span", { className: "sl-bubble__keyword", children: text.keyword }), text.after] })) : (children) })] }));
}
function splitKeyword(text, keyword) {
    const i = text.toLowerCase().indexOf(keyword.toLowerCase());
    if (i < 0)
        return { before: text, keyword: '', after: '' };
    return {
        before: text.slice(0, i),
        keyword: text.slice(i, i + keyword.length),
        after: text.slice(i + keyword.length),
    };
}
//# sourceMappingURL=CharacterBubble.js.map